import React from 'react';

// A numbered step of a settings page: the number on a rail that runs down to the next step, an Oswald title, a lead
// line under it, then the step's content. The last step of the page sets isLast, which ends the rail.
export default function StepSection({ number = 1, title = '', lead = null, isLast = false, children = null }) {
  return (
    <section className='step-section'>
      <div className='step-rail'>
        <div className='step-num'>{number}</div>
        {!isLast && <div className='step-line' />}
      </div>
      <div className='step-body'>
        <h2 className='step-title'>{title}</h2>
        {lead && <p className='step-lead'>{lead}</p>}
        {children}
      </div>
    </section>
  );
}
